import {
    useImperativeHandle,
    forwardRef,
    useState,
    useRef,
    useMemo,
  } from 'react'
import PrimeModal from '@/components/primeModal'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import MeddraForm from './meddraForm'
import WhoDrugB3Form from './whoDrugB3Form'
import WhoDrugC3Form from './whoDrugC3Form'
import OmopForm from './omopForm'

const AddVModalMulTiFileDict = (props, ref: any) => {
  const { onSuccess, onStart } = props
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)
  const [loading, setLoading] = useState(false)
  const [searchParams] = useSearchParams()
  const isOMOP = searchParams.get('isOMOP')
  const isWHODrugB3 = searchParams.get('isWHODrugB3')
  const isWHODrugC3 = searchParams.get('isWHODrugC3')
  const isMedDRA = searchParams.get('isMedDRA')

  const meddraFormRef = useRef<any>(null);
  const whoDrugB3FormRef = useRef<any>(null);
  const whoDrugC3FormRef = useRef<any>(null);
  const omopFormRef = useRef<any>(null);

  const open = () => {
    setVisible(true)
  }

  const close = () => {
    setVisible(false)
  }

  const memorizedValue = useMemo((): [any, any] =>{
    if (isMedDRA) return [<MeddraForm ref={meddraFormRef} />, meddraFormRef]
    if (isWHODrugB3) return [<WhoDrugB3Form ref={whoDrugB3FormRef} />, whoDrugB3FormRef]
    if (isWHODrugC3) return [<WhoDrugC3Form ref={whoDrugC3FormRef} />, whoDrugC3FormRef]
    if (isOMOP) return [<OmopForm ref={omopFormRef} />, omopFormRef]
    return [null, null]
  }, []);

  const formComp = memorizedValue[0]
  const formRef = memorizedValue[1]
  
  const onOk = async () => {
    try {
      onStart && onStart()
      setLoading(true)
      await formRef?.current?.submit?.();
      setLoading(false)
      formRef?.current?.resetFields?.()
      close();
      onSuccess?.()
    } catch (error) {
      setLoading(false)
    }
  }

  const onCancel = ()=>{
    formRef?.current?.resetFields?.()
    close();
  }

  useImperativeHandle(ref, () => ({
    open,
    close,
  }))

  return (
    <PrimeModal
      title={t('dict.addDirVersion')}
      open={visible}
      onCancel={onCancel}
      onOk={onOk}
      okButtonProps={{
        loading,
        disabled: loading
      }}
      cancelButtonProps={{
        disabled: loading,
      }}
    >
      {formComp}
    </PrimeModal>
  )
}
  
export default forwardRef(AddVModalMulTiFileDict)
  